
import { useContext } from 'react'
import { SnackBarContext } from "./SnackbarProvider";

const useSnackBars = () => useContext(SnackBarContext)

export default useSnackBars